export default {
  ticketInfo: '门票信息',
  ticket_generating: '出票中',
  free_ticket: '免费门票',
  purchase_success: '购买成功',
  periodicalInfo: '期刊信息',
  youMayNeedServices: '您可能还需要如下服务，可在下方添加',
  youMayNeedMoreServices: '您可能还需要以下服务',
  safeTravel: '放心出行',
  securityReminder: '安全提醒',
  weWontLeakInfo:
    '我们不会因任何理由泄露用户信息。如遇陌生号码发送的展会变动、订单异常等信息，切勿轻信，谨防诈骗！',
  electronicPeriodical: '电子会刊｜展商名录',
  clickToView: '点击查看',
  myTickets: '我的门票',
  continueToBuy: '继续购买',
  generatePoster: '生成海报',
  notBookedHotel: '还未预订酒店',
  goToBook: '去预订',
  notAppliedVisa: '还未办理签证',
  goToApply: '去办理',
  subscribeMiniProgram: '关注微信小程序获取电子门票',
  subscribeOfficialAccount: '关注微信公众号获取电子门票',
  bookSuccess: '预订成功',
  bookFailed: '预订失败',
  bookNow: '立即预订',
  visa_application: '签证申请',
  express_handling: '加急办理',
  professional_customer_service: '专业客服',
  itinerary_customization: '行程定制',
  business_itinerary: '商务行程',
  personalized_customization: '个性定制',
  thoughtful_service: '贴心服务',
  success_desc:
    '展会将于 {lunchTime} 举办。请携带身份证原件刷卡入场或至现场服务台换领纸质进馆证！祝您观展顺利！',
  failure_desc: '非常抱歉，您的预订失败了。请重新下单或联系客服寻求帮助。'
}
